import { useLocation } from 'react-router-dom';
import useRouteMeta from '@/hooks/useRouteMeta';
import useRouteSchema from '@/hooks/useRouteSchema';

/**
 * Normalizes a trailing slash so "/bookkeeping/" is treated exactly like
 * "/bookkeeping". The root path "/" is left untouched.
 */
function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.replace(/\/+$/, '') || '/';
  }
  return pathname;
}

/**
 * Mounts the centralized, route-aware SEO managers. Renders nothing and does
 * not change any visible page UI.
 */
export default function RouteSeo() {
  const { pathname } = useLocation();
  const normalizedPathname = normalizePathname(pathname);
  useRouteMeta(normalizedPathname);
  useRouteSchema(normalizedPathname);
  return null;
}